import { FormMapping } from '@shopify/react-form';
import { PersonaPickerOption } from '@sdk/components/forms/personaPickers/PersonaPicker/personaPicker.types';
import { ObjectWithId } from '@sdk/common/types/ObjectWithId';

import { CreateGroupConversationFields } from '@web/conversations/CreateGroupConversation/createGroupConversation.types';

export const getCreateGroupConversationPayload = (
  formFields: FormMapping<CreateGroupConversationFields, 'value'>,
  membersPreProcessor: (personas: PersonaPickerOption) => PersonaPickerOption | ObjectWithId[]
) => {
  const { members, name, restricted, restrictedToUsers } = formFields;

  return {
    name,
    personas: members.flatMap(membersPreProcessor).map(({ id }) => id),
    restricted,
    restrictedToPersonas: restrictedToUsers.map(({ id }) => id),
  };
};
